import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 5.59058H14.25C15.3109 5.59058 16.3283 6.012 17.0784 6.76215C17.8286 7.51229 18.25 8.52971 18.25 9.59058V18.5906C18.25 19.0547 18.0656 19.4998 17.7374 19.828C17.4092 20.1562 16.9641 20.3406 16.5 20.3406H4.5C3.43913 20.3406 2.42172 19.9191 1.67157 19.169C0.921428 18.4189 0.5 17.4014 0.5 16.3406V7.34058C0.5 6.87645 0.684375 6.43133 1.01256 6.10314C1.34075 5.77495 1.78587 5.59058 2.25 5.59058ZM2.5 7.59058H14.25C14.7804 7.59058 15.2891 7.80129 15.6642 8.17636C16.0393 8.55144 16.25 9.06014 16.25 9.59058V18.3406H4.5C3.96957 18.3406 3.46086 18.1299 3.08579 17.7548C2.71071 17.3797 2.5 16.871 2.5 16.3406V7.59058Z",
      fill: "#6E0AFA"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.0021 7.60067C23.3104 7.77959 23.5002 8.10911 23.5002 8.46558V17.4656C23.5002 17.822 23.3104 18.1516 23.0021 18.3305C22.6938 18.5094 22.3135 18.5107 22.004 18.3338L16.754 15.3338C16.2745 15.0598 16.1079 14.449 16.3819 13.9694C16.6559 13.4899 17.2668 13.3233 17.7463 13.5973L21.5002 15.7424V10.1888L17.7463 12.3338C17.2668 12.6078 16.6559 12.4412 16.3819 11.9617C16.1079 11.4822 16.2745 10.8713 16.754 10.5973L22.004 7.59733C22.3135 7.42047 22.6938 7.42174 23.0021 7.60067Z",
      fill: "#6E0AFA"
    }, null, -1)
  ])))
}
export default { render: render }